
import Button from '../../../components/base/Button';

const doctors = [
  {
    name: 'Dr. Juan Pablo Delgadillo Espejo',
    specialty: 'Urólogo Certificado - Guadalajara',
    cedula: 'Cédula Profesional: 11051251',
    cedulaEsp: 'Cédula de Especialidad: 12923120',
    image: 'https://centrourologicoguadalajara.com/juan-pablo.png',
    focus: 'Especialista en cirugía láser y disfunción eréctil en urológica en Guadalajara',
    locations: 'Hospital Belisario Domínguez y Hospital Americas',
    experience: [
      'Gran experiencia en urología  en Guadalajara',
      'Certificado por la UNAM - Clínica UROMÁS',
      'Miembro de la Sociedad Mexicana de Urología',
      'Más de 1000 cirugías realizadas con exito en Guadalajara'
    ]
  },
  {
    name: 'Dr. Omar Martínez Soltero',
    specialty: 'Urólogo Especialista - Guadalajara',
    cedula: 'Cédula Profesional: 133351261',
    cedulaEsp: 'Cédula de Especialidad: 13343422',
    image: 'https://centrourologicoguadalajara.com/omar-martinez.png',
    focus: 'Especialista en disfunción eréctil y medicina sexual masculina en Guadalajara',
    locations: 'Centro de Salud La Cima y Hospital Americas',
    experience: [
      'Gran experiencia en cirugia laser en Guadalajara',
      'Especialista en atención Urológica | UROMÁS',
      'Certificado en medicina sexual masculina',
      'Atencón en cálculos Urinarios y Atención en prostata'
    ]
  }
];

export default function About() {
  return (
    <section id="nosotros" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Manifiesto */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111317] mb-4">
            UroMás Centro Urológico de Guadalajara: Líderes en Urología
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            UroMás Centro Urológico de Guadalajara, Jalisco - El centro urológico de excelencia más reconocido de Guadalajara. Urólogos certificados con tecnología de vanguardia.
          </p>
          
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              <strong>UroMás Centro Urológico de Guadalajara</strong> es reconocido como el centro urológico 
              más prestigioso y confiable de Guadalajara, Jalisco. Nuestro centro urológico ofrece atención 
              médica de clase mundial en el corazón de Guadalajara, combinando la experiencia de los mejores 
              urólogos de Guadalajara con tecnología láser de vanguardia para ofrecer tratamientos urológicos excepcionales.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-[#1B84FF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-[#1B84FF]"></i>
                </div>
                <h3 className="text-xl font-semibold text-[#0B2A4A] mb-3">Centro Urológico Confiable</h3>
                <p className="text-gray-600">
                  UroMás Centro Urológico: Los urólogos más confiables de Guadalajara. 
                  Transparencia y honestidad en cada consulta urológica.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-[#1B84FF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-3xl text-[#1B84FF]"></i>
                </div>
                <h3 className="text-xl font-semibold text-[#0B2A4A] mb-3">Excelencia Urológica</h3>
                <p className="text-gray-600">
                  Centro urológico con estándares médicos de excelencia internacional. 
                  Tecnología láser de vanguardia para cirugía de próstata en Guadalajara.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-[#1B84FF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lock-line text-3xl text-[#1B84FF]"></i>
                </div>
                <h3 className="text-xl font-semibold text-[#0B2A4A] mb-3">Centro Urológico Discreto</h3>
                <p className="text-gray-600">
                  Máxima confidencialidad en nuestro centro urológico. 
                  Ambiente privado y profesional en todas nuestras sedes de Guadalajara.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Equipo Médico */}
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-[#111317] text-center mb-4">
            Los Mejores Urólogos del Centro Urológico UroMás
          </h3>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            Nuestros urólogos especialistas del Centro Urológico UroMás son reconocidos como los 
            mejores urólogos de Guadalajara, Jalisco. Centro urológico con experiencia comprobada y resultados excepcionales.
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {doctors.map((doctor, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="md:flex">
                  <div className="md:w-1/3">
                    <img 
                      src={doctor.image}
                      alt={`${doctor.name} - Urólogo especialista en UROMÁS Guadalajara`}
                      className="w-full h-64 md:h-full object-cover object-top"
                    />
                  </div>
                  
                  <div className="md:w-2/3 p-6">
                    <h4 className="text-xl font-bold text-[#111317] mb-2">
                      {doctor.name}
                    </h4>
                    
                    <p className="text-[#1B84FF] font-semibold mb-2">
                      {doctor.specialty}
                    </p>

                    <p className="text-sm text-gray-500 mb-3">
                      📍 {doctor.locations}
                    </p>
                    
                    <div className="text-sm text-gray-600 mb-4">
                      <p>{doctor.cedula}</p>
                      <p>{doctor.cedulaEsp}</p>
                    </div>
                    
                    <p className="text-gray-700 font-medium mb-4">
                      {doctor.focus}
                    </p>
                    
                    <ul className="space-y-2 mb-6">
                      {doctor.experience.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start text-sm text-gray-600">
                          <i className="ri-check-line text-[#1B84FF] mr-2 mt-0.5 flex-shrink-0"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                    
                    <Button 
                      href={`https://wa.me/523318648274?text=${encodeURIComponent('Quiero una consulta en UroMás:')}`}
                      className="w-full"
                    >
                      <i className="ri-calendar-line mr-2"></i>
                      Consulta con este urólogo
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Sección adicional SEO */}
          <div className="mt-16 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8">
            <div className="text-center">
              <h4 className="text-2xl font-bold text-[#0B2A4A] mb-4">
                ¿Por qué UroMás es el Mejor Centro Urológico de Guadalajara?
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                    <i className="ri-map-pin-line text-2xl text-[#1B84FF]"></i>
                  </div>
                  <h5 className="font-semibold text-[#0B2A4A] mb-2">Centro Urológico Estratégico</h5>
                  <p className="text-sm text-gray-600">Ubicaciones del centro urológico en las mejores zonas de Guadalajara</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                    <i className="ri-flashlight-line text-2xl text-[#1B84FF]"></i>
                  </div>
                  <h5 className="font-semibold text-[#0B2A4N] mb-2">Centro con Tecnología Láser</h5>
                  <p className="text-sm text-gray-600">Centro urológico con equipos láser de última generación</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                    <i className="ri-time-line text-2xl text-[#1B84FF]"></i>
                  </div>
                  <h5 className="font-semibold text-[#0B2A4A] mb-2">Centro Urológico Flexible</h5>
                  <p className="text-sm text-gray-600">Horarios flexibles en nuestro centro urológico</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                    <i className="ri-star-line text-2xl text-[#1B84FF]"></i>
                  </div>
                  <h5 className="font-semibold text-[#0B2A4A] mb-2">Centro con Resultados</h5>
                  <p className="text-sm text-gray-600">Miles de pacientes satisfechos en nuestro centro urológico</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
